/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Creates a model payload to send to the API
 * @param {string} title
 * @param {string=} description
 */
export function CreateModelDto (title, description) {

    const payload = {
        title,
        description
    };

    return payload;
}
